import {
  Equal,
  IQueryCommandOptions,
  convertQueryCommandToQueryString,
} from '@llws/dynamic-router-utils';
import { ITourTrackingEvents } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';
import { adminRequest } from '@/shared/request-configs/admin-request';
import vm from '@/main';
import { IAction, IStateStrictV2 } from '@/shared/interfaces/store-base';

const adminGatewayResourcePath: string = '/tour-api-admin/tour_tracking_events';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {};
const defaultGetSingleFilters: IQueryCommandOptions = {};

const base = new StoreBaseImplementationV2<ITourTrackingEvents>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

export default {
  namespaced: base.namespaced,

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,

    getTourTrackingEventsForClient: async (ctx: IAction<IStateStrictV2<ITourTrackingEvents>>) => {
      const clientId = vm()?.$rsGlobals.$currentClient.id;
      if (!clientId) return;
      const filters: IQueryCommandOptions = {
        where: [Equal('clientId', clientId)],
      };

      const response = await adminRequest.get(`${adminGatewayResourcePath}${convertQueryCommandToQueryString(filters)}`);
      ctx.commit('set', response);
    },
  },
};
